/*global
    jQuery, aap
*/
(function ($) {
  var map;
  function addMarkers() {
    // Used when adding map boundries
    var bounds = new google.maps.LatLngBounds();
  
    // Get list of marker data from external JSON source  
    $.getJSON( '/petco/store-list-json', function(data) { 
        $.each( data.stores, function(index, store) {
            var location = { 'lat': parseFloat(store.lat), 'lng': parseFloat(store.lng) };
            map.setCenter(location);
            var marker_object = new google.maps.Marker({
              map: map,
              position: location,
              bounds: true,
              scrollWheel: false
            });
            
            // Add marker location to map boundries
            bounds.extend (location);
        	map.fitBounds(bounds);
              
              // Build HTML content for infoWindow
              var content_html = "<div style='max-width: 200px; overflow:wrap;'>"+store.name+"<br >"+store.street_address+"</div>";
  
              // Add a new infoWindow and attach it to the new marker just created
              marker_object.info = new google.maps.InfoWindow({
                content: content_html,
                // If we do not disable AutoPan, the map jumps whenever hovering over a marker near the edge
                disableAutoPan: true
              });

              // Add list item for new marker_object to the location list
              add_marker_to_location_list(index, store, marker_object);
  
              // Add hover events to new marker_object
              add_events_to_marker(index, marker_object);
  
              // Add hover events to new location list item
              add_events_to_location_list_item(index, marker_object);
            // Add hover events to new location list item
            //add_events_to_location_list_item(index, marker_object);
        }); // end check status
     }); // end marker JSON loop

     google.maps.event.addListenerOnce(map, 'idle', function(){
         // Set the minimum zoom level based on the current zoom level
         // provided by fitBounds. 
         map.setOptions({minZoom: map.getZoom()});
         
         // delay 1000ms to allow marker boundries to be set as map loads    
         setTimeout(function() {
             limit_drag_to_original_bounds();
         }, 1000);
     });
  }
  function add_events_to_location_list_item(index, marker_object) {
     $("#location_"+index).bind('mouseenter', function() {
       // When hovering over a location list item, show the infoWindow
       // for the corresponding marker_object on the map
       marker_object.info.open(map, marker_object);
  
       // Highlight the location list item
       $(this).addClass("highlight");
     });             
  
     // Close infoWindow when no longer hovering over location list item
     $("#location_"+index).bind('mouseleave', function() {
       marker_object.info.close(map, marker_object);
  
       // Remove highlight class from location list item
       $(this).removeClass("highlight");
     });         
  }

  function limit_drag_to_original_bounds() {
     // store the original Bounds and Center coordinates, to use
     // when comparing viewport coordinates after dragging and
     // reset to if moved outside of original boundries
     var allowedBounds = map.getBounds();
     var lastValidCenter = map.getCenter();
     
     // When drag is triggered, make sure that the original
     // center coordinates remain within the viewport
     // bounds. If they are outside of the bounds, snap
     // back until they are once again within the viewport
     // bounds.
     google.maps.event.addListener(map, 'drag', function() {
         if (allowedBounds.contains(map.getCenter())) {
             // as long as we are still in bounds we can continue
             // to save the center position as the last valid 
             // position
             lastValidCenter = map.getCenter();
             return;
         }

        // when the center value is no longer within bounds
        // we automatically pan back to the last known valid center
        map.panTo(lastValidCenter);
     });
  }

  function add_marker_to_location_list(index, store) {
     // Build HTML content for new marker list location
     //var list_item_html = "<li id='location_item_"+index+"' class='shelter body'><span class='hdr-15px-bold'><a href='http://www.adoptapet.com/adoption_rescue/80016.html'><img src='"+marker_data.img+"' width='115' border='0' align='left' />"+marker_data.content+"</a></span><br />"+marker_data.address+"<br />"+marker_data.phone+"<br />"+marker_data.distance+"<div class='clearfloat'></div></li>";
     var table_item_html = "<tr id='location_"+index+"'><td>"+store.name+"</td><td>"+store.number+"</td><td>"+store.street_address+", "+store.city+", "+store.state_code+" "+store.zipcode+"</td><td>"+store.phone+"</td></tr>";
     // Add marker items to location list
     $("table.tables").append(table_item_html);
  }
  
  function add_events_to_marker(index, marker_object) {
     // Show infoWindow when hovering over a Marker or coresponding list item
     google.maps.event.addListener(marker_object, 'mouseover', function() {
       marker_object.info.open(map, marker_object);
       
       // Add highlight class to the corresponding location list item     
       $("#location_"+index).addClass("highlight");
     });
     
     // Hide infoWindow when leaving a marker
     google.maps.event.addListener(marker_object, 'mouseout', function() {
       marker_object.info.close(map, marker_object);
          
       // Remove highlight class from the corresponding location list item
       $("#location_"+index).removeClass('highlight');
     });
  }

    function initialize() {
        var mapOptions = {
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false
        }

        map = new google.maps.Map(document.getElementById('map'), mapOptions);
        addMarkers();
        google.maps.event.addDomListener(window, "resize", function() {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });
    }

    if(typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        google.maps.event.addDomListener(window, 'load', initialize);
    }
}(jQuery));
